import SiloOption from './SiloOption';
import binIcon from '@web/utils/src/assets/icons/functions/bin-icon.svg';
import feedIcon from '@web/utils/src/assets/icons/functions/feed-icon.svg';

export enum SiloTypes {
  FLAT = 'FLAT',
  HOPPER = 'HOPPER',
}

interface SiloTypeSelectProps {
  type: string;
  handleInputChange: (name: any, value: any) => void;
  t: any;
}

const SiloTypeSelect: React.FC<SiloTypeSelectProps> = ({
  type,
  handleInputChange,
  t,
}) => {
  const options = [
    {
      type: SiloTypes.FLAT,
      label: t(`farm.silos.FLAT`),
      icon: binIcon,
    },
    {
      type: SiloTypes.HOPPER,
      label: t(`farm.silos.HOPPER`),
      icon: feedIcon,
    },
    // Add more options here
  ];

  return (
    <div>
      {options.map((option) => (
        <SiloOption
          key={option.type}
          type={option.type}
          currentType={type}
          handleInputChange={handleInputChange}
          label={option.label}
          icon={option.icon}
        />
      ))}
    </div>
  );
};

export default SiloTypeSelect;
